import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var InstantBookIcon = createIcon({
  displayName: 'InstantBookIcon',
  viewBox: '0 0 36 36',
  path: /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 34.952L2.954 30.25 1.067 1h33.866l-1.887 29.25L18 34.952z",
    fill: "#fff",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.598 17.846l10.11-12.277c.275-.333.809-.056.695.36l-3.37 12.277a.4.4 0 01-.386.294h-6.74a.4.4 0 01-.309-.654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.306 16.165L14.307 28.629c-.283.321-.804.033-.683-.377l3.666-12.465a.4.4 0 01.383-.287h7.333a.4.4 0 01.3.665z"
  })))
});
//# sourceMappingURL=InstantBook.js.map